import {
  Button,
  Card,
  FormControl,
  TextField,
  InputAdornment,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles,
  CardContent,
} from "@material-ui/core";
import React, { Component } from "react";
import * as d3 from "d3";
import { connect } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NumberFormat from "react-number-format";
import D3RepPerformanceStack from "./Charts/D3RepPerformanceStack";
import D3RepPerformanceBar from "./Charts/D3RepPerformanceBar";
import D3BubbleChart from "./Charts/D3BubbleChart";
import { appService } from "../../App/app.service";
import Skeleton from "@material-ui/lab/Skeleton";
import { RepPerformanceTable } from "./Tables/RepPerformanceTable";
import {
  stageFormattter,
  getDefaultSelectedFiscalQuarters,
  getDefaultSalesType,
  countOrACVFormatter,
} from "../../util/customFunctions";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import Drilldown from "../../components/Drilldown/DrilldownWithSLD";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
// import addHeaderdescription from "../../components/HeaderDescription";
import LocationRangeFilter from "../../components/LocationRangeFilter";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import AccountEmpRangeFilter from "../../components/AccountEmpRangeFilterComponent";
import AccountTypeFilter from "../../components/AccountTypeFilterComponent";
import RegionFilter from "../../components/RegionFilterComponent";
import OppSourceChannelFilterComponent from "../../components/OppSourceChannelFilterComponent";
import ChannelTypeFilterComponent from "../../components/ChannelTypeFilterComponent";
import TransactionTypeFilter from "../../components/TransactionTypeFilterCOmponent";
import ExportPPtx from "../../components/ExportPPT";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
const styles = (theme) => ({
  gridContainer: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      height: `calc(100% - ${(window.innerWidth - 288) * 0.1125 + 86}px)`,
    },
  },
});
function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      //prefix="$"
      allowNegative={false}
    />
  );
}

class RepPerformanceAnalysis extends Component {
  Relative_Performance = React.createRef();
  Contribution = React.createRef();
  conversion_rates = React.createRef();

  filters = [
    "closed_fiscal_quarter",
    "Acct_Vertical",
    "Acct_Segment",
    "Acct_Size_Segment",
    "Acct_Industry",
    "Opp_Created_By",
    "Booking_Type_NL_CS_US",
    "Lead_Source",
    "Lead_Source_Category__c",
    "Channel_Partner_Name__c",
    "Solution_Cat",
    "Product_Family",
    "Region",
    "Cust_Type",
    "deal_category__c",
    "cross_sell1__c",
    "Type",
    "team",
    "Opp_Value",
    "ACV_Value",
    "Opportunity_Record_Type",
    "Record_Type_Name__c",
    "Of_Locations_Range",
    "Acct_Emp_Range",
    "Acct_Type",
    "Opportunity_Source_Channel__c",
    "Region__c",
    "Channel_Type__c",
    "Closed_Year_Month",
    "Transaction_Type__c",
    "Exclude_Lost_Stage",
    "ACV_Range",
  ];

  state = {
    ACV_Range: ["All"],
    Opportunity_Record_Type: ["All"],
    year: ["all"],
    month: ["all"],
    quarter: ["all"],
    closed_fiscal_quarter: ["All"],
    Closed_Year_Month: ["All"],
    Acct_Vertical: ["All"],
    Acct_Segment: ["All"],
    Acct_Industry: ["All"],
    Acct_Size_Segment: ["All"],
    Opp_Created_By: ["All"],
    Booking_Type_NL_CS_US: ["All"],
    Lead_Source: ["All"],
    Lead_Source_Category__c: ["All"],
    Channel_Partner_Name__c: ["All"],
    Solution_Cat: ["All"],
    Product_Family: ["All"],
    Region: ["All"],
    Cust_Type: ["All"],
    deal_category__c: ["All"],
    cross_sell1__c: ["All"],
    Type: ["All"],
    team: ["All"],
    disabled: ["year", "month", "quarter"],
    timeFrame: "quarter",
    topReps: [],
    topCalculated: false,
    topRepsTable: [],
    benchmarks: [],
    benchmarks_acv: [],
    acv: null,
    acvlt: null,
    filtersForDrilldown: [],
    repFilters: [],
    secondLevelLocation: null,
    Opp_Value: ["All"],
    ACV_Value: ["All"],
    Record_Type_Name__c: ["All"],
    Of_Locations_Range: ["All"],
    Acct_Emp_Range: ["All"],
    Acct_Type: ["All"],
    Region__c: ["All"],
    Channel_Type__c: ["All"],
    Opportunity_Source_Channel__c: ["All"],
    activeTimeFilter: "closed_fiscal_quarter",
    Transaction_Type__c: ["All"],
    Exclude_Lost_Stage: ["All"],
  };
  variableCols =
    this.props.company === "C0003"
      ? {
          Industry: "Acct_Vertical",
          CustomerSegment: "Acct_Segment",
          CustomerType: "Region",
          LeadSource: "Lead_Source",
          OppCreatedBy: "Opp_Created_By",
          SolutionCat: "Booking_Type_NL_CS_US",
          ACV_Range: "ACV_Range",
        }
      : {
          Industry: "Acct_Industry",
          CustomerSegment: "Acct_Size_Segment",
          CustomerType: "Cust_Type",
          LeadSource: "Lead_Source",
          Lead_Source_Category__c:"Lead_Source_Category__c",
          Channel_Partner_Name__c:"Channel_Partner_Name__c",
          OppCreatedBy: "Opp_Created_By",
          SolutionCat: "Solution_Cat",
          deal_category__c: "deal_category__c",
          cross_sell1__c: "cross_sell1__c",
          Type: "Type",
          Record_Type_Name__c: "Record_Type_Name__c",
          Of_Locations_Range: "Of_Locations_Range",
          Acct_Emp_Range: "Acct_Emp_Range",
          Acct_Type: "Acct_Type",
          Opportunity_Source_Channel__c: "Opportunity_Source_Channel__c",
          Region__c: "Region__c",
          Channel_Type__c: "Channel_Type__c",
          Transaction_Type__c: "Transaction_Type__c",
          Exclude_Lost_Stage: "Exclude_Lost_Stage",
          ACV_Range: "ACV_Range",
        };
  onAcvLtChange = (event, value) => {
    this.setState({
      ...this.state,
      acvlt: value,
    });
  };
  handleChange = (e) => {
    if (
      e.target.name === "year" &&
      e.target.value.filter((v) => v === "All").length > 0
    ) {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        month: ["All"],
        quarter: ["All"],
      });
    } else {
      const { name, value } = e.target;
      let newValue;
      let activeTimeFilter = this.state.activeTimeFilter;
      if (["closed_fiscal_quarter", "Closed_Year_Month"].includes(name)) {
        activeTimeFilter = name;
      }

      if (name === "rep") {
        newValue = [value];
      } else if (value.length === 0) {
        newValue = ["All"];
      } else if (
        this.state[name].length === 1 &&
        this.state[name].includes("All")
      ) {
        const filtered = value.filter((v) => v !== "All");
        newValue = filtered.length > 0 ? filtered : ["All"];
      } else if (value.includes("All")) {
        newValue = ["All"];
      } else {
        newValue = value;
      }

      this.setState({
        ...this.state,
        [name]: newValue,
        activeTimeFilter,
      });
    }
  };

  handleChangeNew = (filteredValues) => {
    this.setState({
      ...this.state,
      team:
        this.state.team.length === 1 && this.state.team.includes("All")
          ? filteredValues.filter((v) => v !== "All").length > 0
            ? filteredValues.filter((v) => v !== "All")
            : ["All"]
          : filteredValues.includes("All")
          ? ["All"]
          : filteredValues,
    });
  };

  handleChangeLocation = (location, stage, lastStage, key, rep) => {
    var wonLabel = this.props.repPerformanceData.labels.filter(
      (item) => item.type === "won"
    )[0].label;
    //  console.log(stage, wonLabel)
    var header =
      lastStage || stage === wonLabel
        ? `${stage.replace(/_/g, " ")} Opportunities`
        : key === "lost"
        ? `Lost / Disqualified from ${
            Array.isArray(stage) ? "Open" : stage.replace(/_/g, " ")
          } stage`
        : key === "cameTo"
        ? `Came to ${stage.replace(/_/g, " ")} stage`
        : key === "movedOn"
        ? `Moved Forward from ${stage.replace(/_/g, " ")} stage`
        : `Opportunities lost at ${stage.replace(/_/g, " ")} stage`;

    let repFilters = [];
    if (rep) {
      repFilters = [
        { title: "Rep", value: typeof rep === "string" ? [rep] : rep },
      ];
    } else {
      repFilters = [{ title: "Rep", value: ["All"] }];
    }

    this.setState({
      ...this.state,
      location: location,
      selectedDrilldownStage: stage,
      lastStage: lastStage,
      header,
      repFilters: [
        {
          title: "Rep",
          value:
            typeof rep === "string" ? [rep] : rep.length === 1 ? rep : ["All"],
        },
      ],
      filtersForDrilldown: [...this.state.filtersForDrilldown],
    });
    // console.log(rep)

    let filters = this.props.currentFilters;
    if (rep !== "All") {
      filters = [
        ...filters,
        { name: "Owner_Name", value: typeof rep === "string" ? [rep] : rep },
      ];
    }

    if (location !== "overview") {
      this.props.getClosedDrilldownOnGraph(key, {
        stage: Array.isArray(stage) ? stage : [stage],
        filters: filters,
      });
    } else {
      this.props.clearDrilldownData();
    }
  };

  passFiltersForDrilldown = () => {
    let filtersArray = [];

    if (!this.state.closed_fiscal_quarter.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Closed Fiscal Qtr.",
          value: this.state.closed_fiscal_quarter.sort(),
        },
      ];
    }

    if (!this.state.Acct_Emp_Range.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Emp. Range",
          value: this.state.Acct_Emp_Range.sort(),
        },
      ];
    }

    if (!this.state.Exclude_Lost_Stage.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Exclude Lost Stage",
          value: this.state.Exclude_Lost_Stage.sort(),
        },
      ];
    }
    if (!this.state.Opp_Value.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Pursued Opps >=",
          value: this.state.Opp_Value,
        },
      ];
    }

    if (!this.state.ACV_Value.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: `Pursued ${this.props.Value_Label} >=`,
          value: this.state.ACV_Value,
        },
      ];
    }
    if (!this.state.Channel_Type__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === 'C0023' ? "Deal Type":"Channel Type",
          value: this.state.Channel_Type__c.sort(),
        },
      ];
    }
    if (!this.state.Opportunity_Source_Channel__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Opp Source Channel",
          value: this.state.Opportunity_Source_Channel__c.sort(),
        },
      ];
    }
    if (!this.state.Region__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Region",
          value: this.state.Region__c.sort(),
        },
      ];
    }

    if (!this.state.Acct_Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Type",
          value: this.state.Acct_Type.sort(),
        },
      ];
    }

    if (!this.state.team.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Team", value: this.state.team },
      ];

    if (!this.state.Transaction_Type__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Transaction Type", value: this.state.Transaction_Type__c },
      ];

    if (!this.state.Booking_Type_NL_CS_US.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Type", value: this.state.Booking_Type_NL_CS_US },
      ];

    if (!this.state.Record_Type_Name__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opp Record Type", value: this.state.Record_Type_Name__c },
      ];

    if (this.state.acv !== null && this.state.acv !== 0) {
      filtersArray = [
        ...filtersArray,
        {
          title: `${this.props.Value_Label} >=`,
          value:
            `${this.props.Currency_Symbol}` +
            d3.format(",")(
              this.state.acv && typeof this.state.acv === "string"
                ? this.state.acv.match(/,/g)
                  ? this.state.acv.match(/,/g).length === 1
                    ? parseInt(this.state.acv) * 1000
                    : this.state.acv.match(/,/g).length === 2
                    ? parseInt(this.state.acv) * 1000000
                    : parseInt(this.state.acv)
                  : parseInt(this.state.acv)
                : this.state.acv
            ),
        },
      ];
    }
    if (this.state.acvlt !== null && this.state.acvlt !== 0) {
      console.log("drilldownacvlt", this.state.acvlt);

      filtersArray = [
        ...filtersArray,
        {
          title: `${this.props.Value_Label} <=`,
          value:
            `${this.props.Currency_Symbol}` +
            d3.format(",")(
              this.state.acvlt && typeof this.state.acvlt === "string"
                ? this.state.acvlt.match(/,/g)
                  ? this.state.acvlt.match(/,/g).length === 1
                    ? parseInt(this.state.acvlt) * 1000
                    : this.state.acvlt.match(/,/g).length === 2
                    ? parseInt(this.state.acvlt) * 1000000
                    : parseInt(this.state.acvlt)
                  : parseInt(this.state.acvlt)
                : this.state.acvlt
            ),
        },
      ];
    }
    if (!this.state.Acct_Industry.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Vertical" : "Industry",
          value:
            this.props.company === "C0003"
              ? this.state.Acct_Vertical
              : this.state.Acct_Industry,
        },
      ];

    if (!this.state.Cust_Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Region" : "Customer Type",
          value:
            this.props.company === "C0003"
              ? this.state.Region
              : this.state.Cust_Type,
        },
      ];
    if (!this.state.Lead_Source.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Lead Source", value: this.state.Lead_Source },
      ];

    if (!this.state.Lead_Source_Category__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Lead Source Category", value: this.state.Lead_Source_Category__c },
      ];

    if (!this.state.Channel_Partner_Name__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Channel Partner Name", value: this.state.Channel_Partner_Name__c },
      ];
    
    if (!this.state.Opp_Created_By.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Created By", value: this.state.Opp_Created_By },
      ];

    if (!this.state.Solution_Cat.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Solution Category", value: this.state.Solution_Cat },
      ];

    if (!this.state.Product_Family.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Product Family Contains", value: this.state.Product_Family },
      ];

    if (!this.state.Opportunity_Record_Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: "Opportunity Record Type",
          value: this.state.Opportunity_Record_Type,
        },
      ];

    if (!this.state.deal_category__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Deal Category", value: this.state.deal_category__c },
      ];

    if (!this.state.ACV_Range.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: `${this.props.Value_Label} Range`, value: this.state.ACV_Range },
      ];

    if (!this.state.Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0008" ? "Deal Type" : "Opp. Type",
          value: this.state.Type,
        },
      ];

    if (!this.state[this.variableCols.CustomerSegment].includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: "Customer Segment",
          value: this.state[this.variableCols.CustomerSegment],
        },
      ];

    return filtersArray;
  };

  handleChangeLocationBack = (location) => {
    this.setState(
      {
        ...this.state,
        location: location,
        secondLevelLocation: location,
        repFilters: [],
      },
      () => {
        window.scrollTo({
          top: document.documentElement.scrollHeight, // Scroll to the bottom of the page
          // behavior: "smooth", // Optional: for smooth scrolling
        });
      }
    );
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      secondLevelLocation: location,
    });
    this.props.getOpenOppData(oppId);
  };

  stepBack = () => {
    this.setState({
      ...this.state,
      secondLevelLocation: "",
    });
    this.props.clearExpectedAcvData();
  };

  handleGo = () => {
    localStorage.removeItem("skygeni-auto-update");
    let filters = this.filters
      .map((f) => {
        return {
          name: f,
          value:
            f === "rep"
              ? this.state[f].includes("All")
                ? "All"
                : this.getSelectedRepIDs()
              : this.state[f],
          string: this.props.funnelCompareFilters.filter(
            (i) => i.type === f && i[f] === this.state[f][0]
          )[0]
            ? this.props.funnelCompareFilters.filter(
                (i) => i.type === f && i[f] === this.state[f][0]
              )[0].string === "Y"
            : "",
        };
      })
      .filter(
        (f) =>
          (!Array.isArray(f.value) && f.value !== "All") ||
          !f.value.includes("All")
      )
      .filter((f) => !this.state.disabled.includes(f.name));
    if (this.state.acv !== null) {
      filters = [
        ...filters,
        {
          name: "acv",
          value: parseInt(this.state.acv),
          string: false,
        },
      ];
    }
    if (this.state.acvlt !== null) {
      filters = [
        ...filters,
        {
          name: "acvlt",
          value: parseInt(this.state.acvlt),
          string: false,
        },
      ];
    }
    this.props.getRepPerformanceData(filters, this.state.activeTimeFilter);

    this.setState({
      ...this.state,

      filtersForDrilldown: this.passFiltersForDrilldown(),
    });
  };
  componentDidMount() {
    this.props.getfunnelCompareFilters(this.props.company);
    window.addEventListener("resize", this.onResize);
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.funnelCompareFilters !== "" &&
      prevProps.funnelCompareFilters === ""
    ) {
      var salesTypes = ["All"];
      var dealsTypes = ["All"];
      let solutioncat = ["All"];
      dealsTypes = getDefaultSalesType(
        this.props.funnelCompareFilters.filter((s) => s.type === "Type"),
        "Type"
      );
      solutioncat = getDefaultSalesType(
        this.props.funnelCompareFilters.filter(
          (s) => s.type === "Solution_Cat"
        ),
        "Solution_Cat"
      );
      if (this.props.company === "C0008") {
        salesTypes = getDefaultSalesType(
          this.props.funnelCompareFilters.filter(
            (s) => s.type === "cross_sell1__c"
          ),
          "cross_sell1__c"
        );
        dealsTypes = getDefaultSalesType(
          this.props.funnelCompareFilters.filter((s) => s.type === "Type"),
          "Type"
        );
      }

      let OppVal = getDefaultSalesType(
        this.props.funnelCompareFilters.filter((s) => s.type === "Opp_Value"),
        "Opp_Value"
      );

      let ACVVal = getDefaultSalesType(
        this.props.funnelCompareFilters.filter((s) => s.type === "ACV_Value"),
        "ACV_Value"
      );

      //Set team filter default value
      let defaultvalueTeam;

      if (this.props.funnelCompareFilters !== "") {
        const val = this.props.funnelCompareFilters.find((filter) =>
          filter.hasOwnProperty("parentChildrenTeamFilter")
        );
        defaultvalueTeam = val.parentChildrenTeamFilter.defaultValueTeam;
      }

      this.setState({
        ...prevState,
        team: defaultvalueTeam ? defaultvalueTeam : ["All"],
        closed_fiscal_quarter: getDefaultSelectedFiscalQuarters(
          this.props.funnelCompareFilters,
          "closed_fiscal_quarter"
        ),
        cross_sell1__c: salesTypes,
        Type: dealsTypes,
        Opp_Value: OppVal,
        ACV_Value: ACVVal,
        Type: dealsTypes,
        Solution_Cat: solutioncat,
      });
    }
    if (this.props.repPerformanceData !== "" || undefined) {
      D3RepPerformanceBar.destroy(this._rootNode1);
      D3RepPerformanceStack.destroy(this._rootNode2);
      D3BubbleChart.destroy(this._rootNode3);
      this._chart1 = D3RepPerformanceBar.create(this._rootNode1, {
        data: this.props.repPerformanceData.final,
        label: this.props.repPerformanceData.labels,
        Value_Label: `${this.props.Value_Label}`,
      });
      this._chart2 = D3RepPerformanceStack.create(this._rootNode2, {
        data: this.props.repPerformanceData.final,
        label: this.props.repPerformanceData.labels,
        type: "RepPerformance",
      });
      this.chart3 = D3BubbleChart.create(this._rootNode3, {
        data: this.props.repPerformanceData.final,
        label: this.props.repPerformanceData.labels,
      });
    }
  }
  componentWillUnmount = () => {
    window.removeEventListener("resize", this.onResize);
    D3RepPerformanceBar.destroy(this._rootNode1);
    D3RepPerformanceStack.destroy(this._rootNode2);
    D3BubbleChart.destroy(this._rootNode3);
    this.props.clearVariables()
  };
  onResize = async () => {
    D3RepPerformanceBar.destroy(this._rootNode1);
    D3RepPerformanceStack.destroy(this._rootNode2);
    D3BubbleChart.destroy(this._rootNode3);
    this._chart1 = D3RepPerformanceBar.create(this._rootNode1, {
      data: this.props.repPerformanceData.final,
      label: this.props.repPerformanceData.labels,
      Value_Label: `${this.props.Value_Label}`,
    });
    this._chart2 = D3RepPerformanceStack.create(this._rootNode2, {
      data: this.props.repPerformanceData.final,
      label: this.props.repPerformanceData.labels,
      type: "RepPerformance",
    });
    this.chart3 = D3BubbleChart.create(this._rootNode3, {
      data: this.props.repPerformanceData.final,
      label: this.props.repPerformanceData.labels,
    });
  };
  _setRef1(componentNode) {
    this._rootNode1 = componentNode;
  }
  _setRef2(componentNode) {
    this._rootNode2 = componentNode;
  }
  _setRef3(componentNode) {
    this._rootNode3 = componentNode;
  }

  onAcvChange = (event, value) => {
    this.setState({
      ...this.state,
      acv: value,
    });
  };

  onOppValueChange = (event, value) => {
    this.setState({
      ...this.state,
      Opp_Value: value,
    });
  };

  onACVValueChange = (event, value) => {
    this.setState({
      ...this.state,
      ACV_Value: value,
    });
  };
  render() {
    const { classes } = this.props;

    let teamObject;
    if (this.props.funnelCompareFilters !== "") {
      teamObject = this.props.funnelCompareFilters.find((filter) =>
        filter.hasOwnProperty("parentChildrenTeamFilter")
      );
    }
    const gridSplit = this.props.company === "C0017" ? 4 : 2;
    const gridSplitInner = this.props.company === "C0017" ? 6 : 12;
    const filterContainer = this.props.company === "C0017" ? 5 : 6;
    return (
      <div>
        <Grid container justify="flex-start" className={classes.grid}>
          {/* {addHeaderdescription(
            "Rep Performance Analysis",
            "Deep dive into rep performance by stage with this Pareto analysis and dissect conversion rates at various stages of the funnel."
          )} */}
          <AddHeaderDescriptionWithHelperText
            header={`Rep Performance Analysis`}
            description={`Deep dive into rep performance by stage with this Pareto analysis and dissect conversion rates at various stages of the funnel.`}
            helperTextCharts={this.props.helperTextCharts}
          />

          {this.props.funnelCompareFilters !== "" ? (
            <>
              <Grid style={{ margin: "1.5rem" }} item container xs={12}>
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={gridSplit}
                  lg={gridSplit}
                >
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    container
                    component={Paper}
                    justify="space-around"
                  >
                    <Grid item xs={12} sm={gridSplitInner}>
                      <FormControl
                        fullWidth
                        className={classes.formControl}
                        disabled={this.state.Closed_Year_Month[0] !== "All"}
                      >
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.closed_fiscal_quarter.includes(
                              "All"
                            )
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-fiscalQuarter-label"
                        >
                          Closed Fiscal Qtr.:
                        </InputLabel>
                        <Select
                          value={this.state.closed_fiscal_quarter}
                          onChange={this.handleChange}
                          name={"closed_fiscal_quarter"}
                          multiple
                          data-test="closed-fiscal-quarter"
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === "closed_fiscal_quarter" &&
                                  y.closed_fiscal_quarter !== undefined
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y.closed_fiscal_quarter}
                                  value={y.closed_fiscal_quarter}
                                >
                                  {y.closed_fiscal_quarter}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {this.props.company === "C0017" && (
                      <Grid item xs={12} sm={gridSplitInner}>
                        <FormControl
                          fullWidth
                          className={classes.formControl}
                          disabled={
                            this.state.closed_fiscal_quarter[0] !== "All"
                          }
                        >
                          <InputLabel
                            className={classes.filterLabel}
                            style={{
                              color: !this.state.Closed_Year_Month.includes(
                                "All"
                              )
                                ? "#4472c4"
                                : "#000",
                            }}
                            id="select-yearMonth-label"
                          >
                            Closed Month:
                          </InputLabel>
                          <Select
                            value={this.state.Closed_Year_Month}
                            onChange={this.handleChange}
                            name={"Closed_Year_Month"}
                            multiple
                            data-test="closed-year-month"
                          >
                            <MenuItem value={"All"}>All</MenuItem>
                            {this.props.funnelCompareFilters !== "" &&
                              this.props.funnelCompareFilters
                                .filter(
                                  (y) =>
                                    y.type === "Closed_Year_Month" &&
                                    y.Closed_Year_Month !== undefined
                                )
                                .map((y) => (
                                  <MenuItem
                                    key={y.Closed_Year_Month}
                                    value={y.Closed_Year_Month}
                                  >
                                    {y.Closed_Year_Month}
                                  </MenuItem>
                                ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={2}
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12}>
                      <TeamFilterHierarchy
                        label="Team:"
                        value={this.state.team}
                        data={teamObject.parentChildrenTeamFilter.filters}
                        onTeamChange={this.handleChangeNew}
                        name="team"
                        disabled={false}
                        labelColorCondition={!this.state.team.includes("All")}
                        renderValue={(selected) => selected.join(", ")}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) =>
                          option.parentValue + option.label
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={12}
                  lg={4}
                >
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    container
                    component={Paper}
                    justify="space-around"
                  >
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={
                          this.props.funnelCompareFilters.filter(
                            (s) => s.type === "acvFilter"
                          )[0].acv
                        }
                        onChange={this.onAcvChange}
                        value={this.state.acv}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={`${this.props.Value_Label} >= :`}
                            margin="normal"
                            variant="standard"
                            style={{ marginTop: "4px", marginBottom: "0px" }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                color:
                                  this.state.acv !== "" &&
                                  this.state.acv !== null
                                    ? "#4472c4"
                                    : "#000",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              inputComponent: NumberFormatCustom,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    {/* $ */}
                                    {this.props.Currency_Symbol}
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={
                          this.props.funnelCompareFilters.filter(
                            (s) => s.type === "acvFilter"
                          )[0].acv
                        }
                        onChange={this.onAcvLtChange}
                        value={this.state.acvlt}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={`${this.props.Value_Label} <= :`}
                            margin="normal"
                            variant="standard"
                            style={{ marginTop: "4px", marginBottom: "0px" }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                color:
                                  this.state.acvlt !== "" &&
                                  this.state.acvlt !== null
                                    ? "#4472c4"
                                    : "#000",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              inputComponent: NumberFormatCustom,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    {/* $ */}
                                    {this.props.Currency_Symbol}
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid
                  container
                  xs={2}
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12}>
                      <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={this.props.funnelCompareFilters
                          .filter((f) => f.type === "Opp_Value")
                          .map((f) => f.Opp_Value)}
                        // options={this.props.company === 'C0001' ? ['0', '5,000', '10,000', '15,000', '20,000', '30,000', '50,000', '100,000'] : ['0', '50,000', '100,000', '250,000', '500,000', '750,000', '1,000,000']}
                        //getOptionLabel={(option) => typeof (option) === 'string' ? option : stringNumFormatter(parseInt(option))}
                        onChange={this.onOppValueChange}
                        value={this.state.Opp_Value}
                        data-test="Opp_Value"
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Pursued Opps >= :"
                            margin="normal"
                            variant="standard"
                            style={{ marginTop: "0px", marginBottom: "0px" }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                color:
                                  parseInt(this.state.Opp_Value) > 0
                                    ? "#4472c4"
                                    : "#000",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              inputComponent: NumberFormatCustom,
                              startAdornment: (
                                <>
                                  {/* <InputAdornment position="start">
                                  $
                                </InputAdornment> */}
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  xs={2}
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                >
                  <Grid item spacing={2} xs={12} container component={Paper}>
                    <Grid item xs={12}>
                      <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={this.props.funnelCompareFilters
                          .filter((f) => f.type === "ACV_Value")
                          .map((f) => countOrACVFormatter(f.ACV_Value))}
                        onChange={this.onACVValueChange}
                        value={this.state.ACV_Value}
                        data-test="ACV_Value"
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={`Pursued ${this.props.Value_Label} >= :`}
                            margin="normal"
                            variant="standard"
                            style={{
                              marginTop: "0px",
                              marginBottom: "0px",
                              whiteSpace: "nowrap",
                            }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                color:
                                  parseInt(this.state.ACV_Value) > 0
                                    ? "#4472c4"
                                    : "#000",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              inputComponent: NumberFormatCustom,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    {/* $ */}
                                    {this.props.Currency_Symbol}
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                              style: {
                                paddingTop: "0.35rem", // Add top padding here
                                ...params.InputProps.style, // Preserve any existing styles
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={12}
                  lg={filterContainer}
                >
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    container
                    component={Paper}
                    justify="space-around"
                  >
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.Industry
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-industry-label"
                        >
                          {this.props.company === "C0003"
                            ? "Vertical:"
                            : "Industry:"}
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.Industry]}
                          onChange={this.handleChange}
                          name={this.variableCols.Industry}
                          data-test="industry"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.Industry &&
                                  y[this.variableCols.Industry] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.Industry] <
                                b[this.variableCols.Industry]
                                  ? -1
                                  : a[this.variableCols.Industry] >
                                    b[this.variableCols.Industry]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.Industry]}
                                  value={y[this.variableCols.Industry]}
                                >
                                  {y[this.variableCols.Industry]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.CustomerSegment
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                          Customer Segment:
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.CustomerSegment]}
                          onChange={this.handleChange}
                          name={this.variableCols.CustomerSegment}
                          data-test="customer_segment"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type ===
                                    this.variableCols.CustomerSegment &&
                                  y[this.variableCols.CustomerSegment] !== ""
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.CustomerSegment]}
                                  value={y[this.variableCols.CustomerSegment]}
                                >
                                  {y[this.variableCols.CustomerSegment]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.CustomerType
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-industry-label"
                        >
                          {this.props.company === "C0003"
                            ? "Region:"
                            : "Customer Type:"}
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.CustomerType]}
                          onChange={this.handleChange}
                          name={this.variableCols.CustomerType}
                          data-test="customer_type"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.CustomerType &&
                                  y[this.variableCols.CustomerType] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.CustomerType] <
                                b[this.variableCols.CustomerType]
                                  ? -1
                                  : a[this.variableCols.CustomerType] >
                                    b[this.variableCols.CustomerType]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.CustomerType]}
                                  value={y[this.variableCols.CustomerType]}
                                >
                                  {y[this.variableCols.CustomerType]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Lead source, opportunity created by, solution cat */}
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={12}
                  lg={filterContainer}
                >
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    container
                    component={Paper}
                    justify="space-around"
                  >
                    <Grid item xs={12} sm={4}>
                      {this.props.company === "C0024" ? (
                        <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.Lead_Source_Category__c
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                          Lead Source Category:
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.Lead_Source_Category__c]}
                          onChange={this.handleChange}
                          name={this.variableCols.Lead_Source_Category__c}
                          data-test="Lead_Source_Category__c"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.Lead_Source_Category__c &&
                                  y[this.variableCols.Lead_Source_Category__c] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.Lead_Source_Category__c] <
                                b[this.variableCols.Lead_Source_Category__c]
                                  ? -1
                                  : a[this.variableCols.Lead_Source_Category__c] >
                                    b[this.variableCols.Lead_Source_Category__c]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.Lead_Source_Category__c]}
                                  value={y[this.variableCols.Lead_Source_Category__c]}
                                >
                                  {y[this.variableCols.Lead_Source_Category__c]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                      ) : (
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.LeadSource
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-region-label"
                        >
                          Lead Source:
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.LeadSource]}
                          onChange={this.handleChange}
                          name={this.variableCols.LeadSource}
                          data-test="lead_source"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.LeadSource &&
                                  y[this.variableCols.LeadSource] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.LeadSource] <
                                b[this.variableCols.LeadSource]
                                  ? -1
                                  : a[this.variableCols.LeadSource] >
                                    b[this.variableCols.LeadSource]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.LeadSource]}
                                  value={y[this.variableCols.LeadSource]}
                                >
                                  {y[this.variableCols.LeadSource]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.OppCreatedBy
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                            whiteSpace: "nowrap",
                          }}
                          id="select-industry-label"
                        >
                          Opp. created by:
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.OppCreatedBy]}
                          onChange={this.handleChange}
                          name={this.variableCols.OppCreatedBy}
                          data-test="opp_created_by"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.OppCreatedBy &&
                                  y[this.variableCols.OppCreatedBy] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.OppCreatedBy] <
                                b[this.variableCols.OppCreatedBy]
                                  ? -1
                                  : a[this.variableCols.OppCreatedBy] >
                                    b[this.variableCols.OppCreatedBy]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.OppCreatedBy]}
                                  value={y[this.variableCols.OppCreatedBy]}
                                >
                                  {y[this.variableCols.OppCreatedBy]}
                                </MenuItem>
                              ))}{" "}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    {['C0020','C0024'].includes(this.props.company) ? (
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state.Product_Family.includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-industry-label"
                        >
                          Product Family Contains:
                        </InputLabel>
                        <Select
                          value={this.state.Product_Family}
                          onChange={this.handleChange}
                          name={'Product_Family'}
                          data-test="Product_Family"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === "Product_Family" &&
                                  y['Product_Family'] !== ""
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y['Product_Family']}
                                  value={y['Product_Family']}
                                >
                                  {y['Product_Family']}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <FormControl fullWidth className={classes.formControl}>
                        <InputLabel
                          className={classes.filterLabel}
                          style={{
                            color: !this.state[
                              this.variableCols.SolutionCat
                            ].includes("All")
                              ? "#4472c4"
                              : "#000",
                          }}
                          id="select-industry-label"
                        >
                          {this.props.company === "C0003"
                            ? "Opportunity Type"
                            : "Solution Category"}
                          :
                        </InputLabel>
                        <Select
                          value={this.state[this.variableCols.SolutionCat]}
                          onChange={this.handleChange}
                          name={this.variableCols.SolutionCat}
                          data-test="solution_category"
                          multiple
                        >
                          <MenuItem value={"All"}>All</MenuItem>
                          {this.props.funnelCompareFilters !== "" &&
                            this.props.funnelCompareFilters
                              .filter(
                                (y) =>
                                  y.type === this.variableCols.SolutionCat &&
                                  y[this.variableCols.SolutionCat] !== ""
                              )
                              .sort((a, b) =>
                                a[this.variableCols.SolutionCat] <
                                b[this.variableCols.SolutionCat]
                                  ? -1
                                  : a[this.variableCols.SolutionCat] >
                                    b[this.variableCols.SolutionCat]
                                  ? 1
                                  : 0
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y[this.variableCols.SolutionCat]}
                                  value={y[this.variableCols.SolutionCat]}
                                >
                                  {y[this.variableCols.SolutionCat]}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container item xs={12}>
                  <Grid
                    container
                    item
                    style={{ padding: 10, paddingTop: 15 }}
                    xs={2}
                    lg={2}
                  >
                    <Grid
                      item
                      spacing={2}
                      xs={12}
                      container
                      component={Paper}
                      justify="space-around"
                    >
                      <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.formControl}>
                          <InputLabel
                            className={classes.filterLabel}
                            style={{
                              color: !this.state[
                                this.variableCols.ACV_Range
                              ].includes("All")
                                ? "#4472c4"
                                : "#000",
                            }}
                            id="select-aCV_range-label"
                          >
                            {`${this.props.Value_Label} Range`}:
                          </InputLabel>
                          <Select
                            value={this.state[this.variableCols.ACV_Range]}
                            onChange={this.handleChange}
                            name={this.variableCols.ACV_Range}
                            data-test="ACV_Range"
                            multiple
                          >
                            <MenuItem value={"All"}>All</MenuItem>
                            {this.props.funnelCompareFilters !== "" &&
                              this.props.funnelCompareFilters
                                .filter(
                                  (y) =>
                                    y.type === this.variableCols.ACV_Range &&
                                    y[this.variableCols.ACV_Range] !== ""
                                )
                                .map((y) => (
                                  <MenuItem
                                    key={y[this.variableCols.ACV_Range]}
                                    value={y[this.variableCols.ACV_Range]}
                                  >
                                    {y[this.variableCols.ACV_Range]}
                                  </MenuItem>
                                ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  {this.props.company === "C0001" && (
                    <Grid
                      container
                      item
                      style={{ padding: 10, paddingTop: 15 }}
                      xs={2}
                      lg={2}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        justify="space-around"
                      >
                        <Grid item xs={12} sm={12}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              style={{
                                color: !this.state[
                                  this.variableCols.deal_category__c
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Deal Category:
                            </InputLabel>
                            <Select
                              value={
                                this.state[this.variableCols.deal_category__c]
                              }
                              onChange={this.handleChange}
                              name={this.variableCols.deal_category__c}
                              data-test="deal_category__c"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type ===
                                        this.variableCols.deal_category__c &&
                                      y[this.variableCols.deal_category__c] !==
                                        ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={
                                        y[this.variableCols.deal_category__c]
                                      }
                                      value={
                                        y[this.variableCols.deal_category__c]
                                      }
                                    >
                                      {y[this.variableCols.deal_category__c]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/*New filters*/}

                  {this.props.company === "C0008" && (
                    <Grid
                      container
                      item
                      style={{
                        padding: 10,
                        paddingTop: 15,
                      }}
                      xs={4}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        justify="space-around"
                      >
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              style={{
                                color: !this.state[
                                  this.variableCols.cross_sell1__c
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Sales Type:
                            </InputLabel>
                            <Select
                              value={
                                this.state[this.variableCols.cross_sell1__c]
                              }
                              onChange={this.handleChange}
                              name={this.variableCols.cross_sell1__c}
                              data-test="cross_sell1__c"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type ===
                                        this.variableCols.cross_sell1__c &&
                                      y[this.variableCols.cross_sell1__c] !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[this.variableCols.cross_sell1__c]}
                                      value={
                                        y[this.variableCols.cross_sell1__c]
                                      }
                                    >
                                      {y[this.variableCols.cross_sell1__c]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              style={{
                                color: !this.state[
                                  this.variableCols.Type
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Deal Type:
                            </InputLabel>
                            <Select
                              value={this.state[this.variableCols.Type]}
                              onChange={this.handleChange}
                              name={this.variableCols.Type}
                              data-test="Type"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === this.variableCols.Type &&
                                      y[this.variableCols.Type] !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[this.variableCols.Type]}
                                      value={y[this.variableCols.Type]}
                                    >
                                      {y[this.variableCols.Type]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {/*  */}
                  {this.props.company === "C0013" && (
                    <Grid
                      container
                      item
                      style={{ padding: 10, paddingTop: 15 }}
                      // justify="space-between"
                      xs={2}
                      // md={12}
                      // lg={4}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        // style={{ paddingTop: 8 }}
                      >
                        <Grid item xs={12} sm={12}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              // style={{ color: "#4472c4" }}
                              style={{
                                color:
                                  !this.state.Opportunity_Record_Type.includes(
                                    "All"
                                  )
                                    ? "#4472c4"
                                    : "#000",
                              }}
                              id="select-region-label"
                            >
                              Opportunity Record Type:
                            </InputLabel>
                            <Select
                              data-test="Opportunity_Record_Type"
                              value={this.state.Opportunity_Record_Type}
                              onChange={this.handleChange}
                              name="Opportunity_Record_Type"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === "Opportunity_Record_Type" &&
                                      y.Opportunity_Record_Type !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y.Opportunity_Record_Type}
                                      value={y.Opportunity_Record_Type}
                                    >
                                      {y.Opportunity_Record_Type}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {/* C0010 Opp Record Type */}
                  {this.props.company === "C0010" && (
                    <Grid
                      container
                      item
                      style={{ padding: 10, paddingTop: 15 }}
                      // justify="space-between"
                      xs={2}
                      // md={12}
                      // lg={4}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        // style={{ paddingTop: 8 }}
                      >
                        <Grid item xs={12} sm={12}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              // style={{ color: "#4472c4" }}
                              style={{
                                color: !this.state.Record_Type_Name__c.includes(
                                  "All"
                                )
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Oppo Record Type:
                            </InputLabel>
                            <Select
                              data-test="Record_Type_Name__c"
                              value={this.state.Record_Type_Name__c}
                              onChange={this.handleChange}
                              name="Record_Type_Name__c"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === "Record_Type_Name__c" &&
                                      y.Record_Type_Name__c !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y.Record_Type_Name__c}
                                      value={y.Record_Type_Name__c}
                                    >
                                      {y.Record_Type_Name__c}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {["C0017","C0024"].includes(this.props.company) && (
                    <Grid
                      container
                      item
                      style={{
                        padding: 10,
                        paddingTop: 15,
                      }}
                      // justify="space-between"
                      xs={2}
                      // md={12}
                      // lg={4}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        // style={{ paddingTop: 8 }}
                      >
                        <Grid item xs={12} sm={12}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              // style={{ color: "#4472c4" }}
                              style={{
                                color: !this.state.Type.includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Opp. Type:
                            </InputLabel>
                            <Select
                              data-test="Type"
                              value={this.state.Type}
                              onChange={this.handleChange}
                              name="Type"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) => y.type === "Type" && y.Type !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem key={y.Type} value={y.Type}>
                                      {y.Type}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {["C0024"].includes(this.props.company) && (
                    <Grid
                      container
                      item
                      style={{
                        padding: 10,
                        paddingTop: 15,
                      }}
                      xs={2}
                    >
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                      >
                        <Grid item xs={12} sm={12}>
                          <FormControl
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel
                              className={classes.filterLabel}
                              style={{
                                color: !this.state.Type.includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              Channel Partner Name:
                            </InputLabel>
                            <Select
                              data-test="Channel_Partner_Name__c"
                              value={this.state.Channel_Partner_Name__c}
                              onChange={this.handleChange}
                              name="Channel_Partner_Name__c"
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {this.props.funnelCompareFilters !== "" &&
                                this.props.funnelCompareFilters
                                  .filter(
                                    (y) => y.type === "Channel_Partner_Name__c" && y.Channel_Partner_Name__c !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem key={y.Channel_Partner_Name__c} value={y.Channel_Partner_Name__c}>
                                      {y.Channel_Partner_Name__c}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {this.props.company === "C0020" && (
                    <>
                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <LocationRangeFilter
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Of_Locations_Range &&
                              y[this.variableCols.Of_Locations_Range] !== ""
                          )}
                          value={this.state.Of_Locations_Range}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>

                      <Grid
                        container
                        item
                        style={{
                          padding: 10,
                          paddingTop: 15,
                        }}
                        // justify="space-between"
                        xs={2}
                        // md={12}
                        // lg={4}
                      >
                        <Grid
                          item
                          spacing={2}
                          xs={12}
                          container
                          component={Paper}
                          // style={{ paddingTop: 8 }}
                        >
                          <Grid item xs={12} sm={12}>
                            <FormControl
                              fullWidth
                              className={classes.formControl}
                            >
                              <InputLabel
                                className={classes.filterLabel}
                                // style={{ color: "#4472c4" }}
                                style={{
                                  color:
                                    !this.state.Exclude_Lost_Stage.includes(
                                      "All"
                                    )
                                      ? "#4472c4"
                                      : "#000",
                                }}
                                id="select-region-label"
                              >
                                Exclude Lost Stage:
                              </InputLabel>
                              <Select
                                data-test="Exclude_Lost_Stage"
                                value={this.state.Exclude_Lost_Stage}
                                onChange={this.handleChange}
                                name="Exclude_Lost_Stage"
                                multiple
                              >
                                <MenuItem value={"All"}>None</MenuItem>
                                {this.props.funnelCompareFilters !== "" &&
                                  this.props.funnelCompareFilters
                                    .filter(
                                      (y) =>
                                        y.type === "Exclude_Lost_Stage" &&
                                        y.Exclude_Lost_Stage !== ""
                                    )
                                    .map((y) => (
                                      <MenuItem
                                        key={y.Exclude_Lost_Stage}
                                        value={y.Exclude_Lost_Stage}
                                      >
                                        {y.Exclude_Lost_Stage}
                                      </MenuItem>
                                    ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {/*  */}
                  {this.props.company === "C0021" && (
                    <>
                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <RegionFilter
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Region__c &&
                              y[this.variableCols.Region__c] !== ""
                          )}
                          value={this.state.Region__c}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>

                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <OppSourceChannelFilterComponent
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type ===
                                this.variableCols
                                  .Opportunity_Source_Channel__c &&
                              y[
                                this.variableCols.Opportunity_Source_Channel__c
                              ] !== ""
                          )}
                          value={this.state.Opportunity_Source_Channel__c}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>

                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <ChannelTypeFilterComponent
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Channel_Type__c &&
                              y[this.variableCols.Channel_Type__c] !== ""
                          )}
                          value={this.state.Channel_Type__c}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                          company={this.props.company}
                        />
                      </Grid>
                    </>
                  )}
                  {/*  */}
                  {this.props.company === "C0022" && (
                    <>
                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <AccountTypeFilter
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Acct_Type &&
                              y[this.variableCols.Acct_Type] !== ""
                          )}
                          value={this.state.Acct_Type}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>

                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <AccountEmpRangeFilter
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Acct_Emp_Range &&
                              y[this.variableCols.Acct_Emp_Range] !== ""
                          )}
                          value={this.state.Acct_Emp_Range}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>
                    </>
                  )}

                  {this.props.company === "C0023" && (
                    <>
                      <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <TransactionTypeFilter
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type ===
                                this.variableCols.Transaction_Type__c &&
                              y[this.variableCols.Transaction_Type__c] !== ""
                          )}
                          value={this.state.Transaction_Type__c}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                        />
                      </Grid>

                       <Grid
                        container
                        item
                        style={{ padding: 10, paddingTop: 15 }}
                        xs={2}
                      >
                        <ChannelTypeFilterComponent
                          classes={classes}
                          options={this.props.funnelCompareFilters.filter(
                            (y) =>
                              y.type === this.variableCols.Channel_Type__c &&
                              y[this.variableCols.Channel_Type__c] !== ""
                          )}
                          value={this.state.Channel_Type__c}
                          onChange={this.handleChange}
                          paddingAvailable={true}
                          company={this.props.company}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid
                    container
                    item
                    style={{ marginBottom: 10, padding: 10 }}
                    justify="space-between"
                    xs={2}
                    lg={2}
                  >
                    <Grid item xs={4} xl={3} container justify="flex-end">
                      <Button
                        data-test="go"
                        variant="contained"
                        color="primary"
                        onClick={this.handleGo}
                      >
                        GO
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              item
              container
              component={Card}
              style={{ margin: "0.5rem" }}
              justify="center"
            >
              <Skeleton
                variant="react"
                animation="wave"
                height={120}
                width="98%"
                style={{ margin: "1rem" }}
              />
            </Grid>
          )}
          {typeof this.props.repPerformanceData === "string" &&
          this.props.repPerformanceData !== "" ? (
            <Grid item container>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h2">
                      {this.props.repPerformanceData}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} style={{ margin: "0.5rem" }}>
                <Card style={{ margin: "auto", width: "98%" }} raised={true}>
                  <div
                    test="test1"
                    style={{
                      display: "flex",
                      justifyContent: "space-between", // Ensures spacing between the title and the button
                      alignItems: "center", // Aligns items vertically in the center
                      width: "100%",
                      marginRight: "5%",
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        textAlign: "center",
                        flexGrow: 1,
                      }}
                    >
                      Relative Performance
                    </Typography>
                    <div style={{ marginRight: 10 }}>
                      <ExportPPtx
                        chartRef={this.Relative_Performance}
                        title={"Relative Performance"}
                      />
                    </div>
                  </div>
                  {this.props.repPerformanceData ? (
                    <div ref={this.Relative_Performance}>
                      <div
                        style={{
                          justifyContent: "center",
                          marginTop: 20,
                          margin: "auto",
                          width: "95%",
                        }}
                        className="line-container"
                        ref={this._setRef1.bind(this)}
                      />
                    </div>
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width="95%"
                      height={230}
                      style={{ margin: "1rem" }}
                    />
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} style={{ margin: "0.5rem" }}>
                <Card style={{ margin: "auto", width: "98%" }} raised={true}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center", // Aligns items vertically in the center
                      width: "100%",
                      marginRight: "5%",
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        textAlign: "center",
                        flexGrow: 1,
                      }}
                    >
                      Contribution to total
                    </Typography>
                    <div style={{ marginRight: 10 }}>
                      <ExportPPtx
                        chartRef={this.Contribution}
                        title={"Contribution to total"}
                      />
                    </div>
                  </div>

                  {this.props.repPerformanceData ? (
                    <div ref={this.Contribution}>
                      <div
                        style={{
                          justifyContent: "center",
                          marginTop: 20,
                          margin: "auto",
                          width: "95%",
                        }}
                        className="line-container"
                        ref={this._setRef2.bind(this)}
                      />
                    </div>
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width="95%"
                      height={130}
                      style={{ margin: "1rem" }}
                    />
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} style={{ margin: "0.5rem" }}>
                <Card style={{ margin: "auto", width: "98%" }} raised={true}>
                  {this.props.repPerformanceData ? (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between", // Ensures spacing between the title and the button
                          alignItems: "center", // Aligns items vertically in the center
                          width: "100%",
                          marginRight: "5%",
                        }}
                      >
                        <Typography
                          variant="h2"
                          style={{
                            margin: "1rem",
                            textAlign: "center",
                            flex: 1,
                          }}
                        >
                          {stageFormattter(
                            this.props.repPerformanceData.labels.filter(
                              (item) => item.type === "first"
                            )[0].label
                          )}{" "}
                          to{" "}
                          {stageFormattter(
                            this.props.repPerformanceData.labels.filter(
                              (item) => item.type === "second"
                            )[0].label
                          )}{" "}
                          &{" "}
                          {stageFormattter(
                            this.props.repPerformanceData.labels.filter(
                              (item) => item.type === "second"
                            )[0].label
                          )}{" "}
                          to{" "}
                          {stageFormattter(
                            this.props.repPerformanceData.labels.filter(
                              (item) => item.type === "won"
                            )[0].label
                          )}{" "}
                          conversion rates
                        </Typography>
                        <div style={{ flexShrink: 0, marginRight: 10 }}>
                          {" "}
                          {/* Prevent the Export button from shrinking */}
                          <ExportPPtx
                            chartRef={this.conversion_rates}
                            title={`${stageFormattter(
                              this.props.repPerformanceData.labels.filter(
                                (item) => item.type === "first"
                              )[0].label
                            )} to ${stageFormattter(
                              this.props.repPerformanceData.labels.filter(
                                (item) => item.type === "second"
                              )[0].label
                            )} & ${stageFormattter(
                              this.props.repPerformanceData.labels.filter(
                                (item) => item.type === "second"
                              )[0].label
                            )} to ${stageFormattter(
                              this.props.repPerformanceData.labels.filter(
                                (item) => item.type === "won"
                              )[0].label
                            )} conversion rates`}
                          />
                        </div>
                      </div>
                      <div ref={this.conversion_rates}>
                        <div
                          // id="Rep_Performance_Analysis_Bubble_Chart_svg"
                          style={{
                            justifyContent: "center",
                            marginTop: 20,
                            margin: "auto",
                            width: "95%",
                          }}
                          className="line-container"
                          ref={this._setRef3.bind(this)}
                        />
                      </div>
                    </div>
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width="95%"
                      height={330}
                      style={{ margin: "1rem" }}
                    />
                  )}
                </Card>
              </Grid>

              <Grid item xs={12} style={{ margin: "0.5rem" }}>
                <Paper style={{ margin: "auto", width: "98%" }}>
                  {this.props.repPerformanceData ? (
                    <div>
                      <Typography
                        variant="h2"
                        style={{
                          margin: "2rem 0 0 1rem",
                          padding: "1rem 0 0 0rem",
                          textAlign: "center",
                        }}
                      >
                        All Opportunities that closed from{" "}
                        {stageFormattter(
                          this.props.repPerformanceData.labels.filter(
                            (item) => item.type === "first"
                          )[0].label
                        )}{" "}
                        or later stage
                      </Typography>
                      <RepPerformanceTable
                        repPerformanceData={this.props.repPerformanceData.final}
                        labels={this.props.repPerformanceData.labels}
                        handleChangeLocation={this.handleChangeLocation}
                        Value_Label={this.props.Value_Label}
                        Win_Rate_Prefix={this.props.Win_Rate_Prefix}
                      />
                    </div>
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width="95%"
                      height={330}
                      style={{ margin: "1rem" }}
                    />
                  )}
                </Paper>
              </Grid>
              {this.state.location === "drilldownOnGraph" && (
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "absolute",
                    width: "100%",
                    marginTop: "30px",
                  }}
                >
                  <SingleLevelDrilldown
                    header={this.state.header}
                    back={this.handleChangeLocationBack}
                    filters={[
                      ...this.state.filtersForDrilldown,
                      ...this.state.repFilters,
                    ]}
                  >
                    <Drilldown
                      header={this.state.header}
                      body={this.props.drilldownOnGraphData}
                      company={this.props.company}
                      Value_Label={this.props.Value_Label}
                      handleSecondLevelDrilldown={
                        this.handleSecondLevelDrilldown
                      }
                    />
                  </SingleLevelDrilldown>
                </Grid>
              )}

              {this.state.secondLevelLocation === "drilldownOppId" && (
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "absolute",
                    width: "100%",
                    marginTop: "30px",
                  }}
                >
                  <SingleLevelDrilldown
                    header={"Opportunity Change Events"}
                    back={this.handleChangeLocationBack}
                    stepBack={this.stepBack}
                    filters={[]}
                  >
                    <ExpectedAcvPage
                      body={this.props.ExpectedAcvData}
                      Value_Label={this.props.Value_Label}
                    />
                  </SingleLevelDrilldown>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    funnelCompareFilters,
    repPerformanceData,
    user,
    currentFilters,
    drilldownOnGraphData,
    ExpectedAcvData,
  } = state.app;

  return {
    funnelCompareFilters,
    repPerformanceData: repPerformanceData,
    company: user.company,
    Value_Label: user.Value_Label,
    Currency_Symbol: user.Currency,
    Win_Rate_Prefix: user.Win_Rate_Prefix,
    currentFilters,
    drilldownOnGraphData,
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};
const mapDispatchToProps = (dispatch) => ({
    clearVariables:()=>{
    dispatch({type:"clear_variables"})
  },
  getfunnelCompareFilters: (company) => {
    dispatch({ type: "get_funnelCompare_filters_request" });
    appService.getRepPerformanceAnalysisFilters().then(
      (json) => {
        dispatch({ type: "get_funnelCompare_filters_success", json });
        dispatch({ type: "get_rep_performance_analysis_data_request" });
        let filters = [
          {
            name: "closed_fiscal_quarter",
            value: getDefaultSelectedFiscalQuarters(
              json.message,
              "closed_fiscal_quarter"
            ),
            string: true,
          },
        ];
        if (company === "C0008") {
          const salesFilters = getDefaultSalesType(
            json.message.filter((s) => s.type === "cross_sell1__c"),
            "cross_sell1__c"
          );
          const dealsFilters = getDefaultSalesType(
            json.message.filter((s) => s.type === "Type"),
            "Type"
          );
          filters =
            salesFilters[0] === "All"
              ? filters
              : [...filters, { name: "cross_sell1__c", value: salesFilters }];
          filters =
            dealsFilters[0] === "All"
              ? filters
              : [...filters, { name: "Type", value: dealsFilters }];
        }

        const oppValues = getDefaultSalesType(
          json.message.filter((s) => s.type === "Opp_Value"),
          "Type"
        );

        const ACVValues = getDefaultSalesType(
          json.message.filter((s) => s.type === "ACV_Value"),
          "Type"
        );

        if (oppValues[0] !== "All") {
          filters = [...filters, { name: "Opp_Value", value: oppValues }];
        }

        if (ACVValues[0] !== "All") {
          filters = [...filters, { name: "ACV_Value", value: ACVValues }];
        }

        const deaultOppType = getDefaultSalesType(
          json.message.filter((s) => s.type === "Type"),
          "Type"
        );
        const defaultSolutionCat = getDefaultSalesType(
          json.message.filter((s) => s.type === "Solution_Cat"),
          "Solution_Cat"
        );

        filters =
          deaultOppType[0] === "All"
            ? filters
            : [...filters, { name: "Type", value: deaultOppType }];
        filters =
          defaultSolutionCat[0] === "All"
            ? filters
            : [...filters, { name: "Solution_Cat", value: defaultSolutionCat }];

        dispatch({ type: "current_selected_filters", filters });
        appService
          .getRepPerformanceAnalysisData(
            json.message.length === 0 ? [] : filters,
            "closed_fiscal_quarter"
          )
          .then(
            (json) => {
              dispatch({
                type: "get_rep_performance_analysis_data_success",
                json,
              });
            },
            (error) => {
              if (typeof error === "object")
                dispatch({
                  type: "get_rep_performance_analysis_data_failure",
                  error: "Something went wrong",
                });
              else
                dispatch({
                  type: "get_rep_performance_analysis_data_failure",
                  error,
                });
            }
          );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnelCompare_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnelCompare_filters_failure", error });
      }
    );
  },
  getRepPerformanceData: (filters = [], key) => {
    dispatch({ type: "get_rep_performance_analysis_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getRepPerformanceAnalysisData(filters, key).then(
      (json) => {
        dispatch({ type: "get_rep_performance_analysis_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_rep_performance_analysis_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({
            type: "get_rep_performance_analysis_data_failure",
            error,
          });
      }
    );
  },
  getClosedDrilldownOnGraph: (key, filters) => {
    console.log(key, filters);
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.closedDrilldownOnGraph(key, filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});
const connectedRepPerformanceAnalysis = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RepPerformanceAnalysis));
export { connectedRepPerformanceAnalysis as RepPerformanceAnalysis };
